
import React from "react";

const features = [
  {
    icon: "/images/icons/feature-icon-5-1.svg",
    title: "Best Price Guarantee",
    text: "Affordable airport transfers and outstation taxi services with transparent pricing.",
  },
  {
    icon: "/images/icons/feature-icon-5-2.svg",
    title: "Easy & Quick Booking",
    text: "Book your cab instantly with our simple online and phone booking process.",
  },
  {
    icon: "/images/icons/feature-icon-5-3.svg",
    title: "24x7 Cab Availability",
    text: "Round-the-clock airport pickup, drop, local, and outstation taxi services.",
  },
];

const AboutSection = ({
  buttonLink = "/contact-us",
  buttonText = "Contact Us",
}) => {
  return (
    <section className="about--layout5 bottom shape-mockup-wrap">
      {/* Shape */}
      <div
        className="shape-mockup d-none d-xl-block z-index-n1"
        style={{ bottom: "-1%", right: "0%" }}
      >
        <img
          src="/images/shape/about-shape-5-1.svg"
          alt="shape"
        />
      </div>

      <div className="element"></div>

      <div className="container">
        <div className="row align-items-center justify-content-between">
          {/* Left Images */}
          <div className="col-xl-6">
            <div className="img-box5">
              <div className="img-box__img1">
                {/* <img
                  className="img1"
                  src="/img/about/about-5-1.jpg"
                  alt="Mumbai Airport Cabs"
                /> */}
                <img
                  className="img1 d-none d-md-block"
                  src="/images/driver.png"
                  alt="Mumbai Airport Cabs"
                />
                <img
                  className="img2"
                  src="/images/about/about-5-2.png"
                  alt="Mumbai Airport Cabs"
                />
              </div>

              <div className="img-box__img2">
                <img
                  className="img3"
                  src="/images/about/about-5-3.jpg"
                  alt="Mumbai Airport Cabs"
                />
              </div>

              {/* Contact Card */}
              <div className="vs-card style2">
                <div
                  className="vs-card__icon"
                  style={{
                    backgroundImage:
                      "url('/images/shape/card-bg-1.svg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <img
                    src="/images/icons/phone-icon-2.svg"
                    alt="phone"
                  />
                </div>

                <span>Call Anytime</span>

                <a href="tel:+919545731161">
                  +91 9545731161
                </a>

                <p>Need a Cab? We're Available 24x7</p>
              </div>
            </div>
          </div>

          {/* Right Content */}
          <div className="col-xl-6">
            <div className="about-content">
              <div className="element"></div>

              <div className="title-area">
                <span className="sec-subtitle">
                  Mumbai Airport Cabs
                </span>

                <h2 className="sec-title h1 mb-30">
                  Reliable Airport Transfers & Outstation Taxi Services
                </h2>

                <p className="sec-text2 pe-xl-4 mb-30">
                  Mumbai Airport Cabs is a trusted cab service provider
                  offering airport transfers, local sightseeing,
                  corporate travel, and outstation taxi services across
                  Mumbai, Navi Mumbai, Thane, Pune, Goa, Nashik,
                  Shirdi, and other major destinations.
                </p>

                <p className="sec-text2 pe-xl-4 mb-30">
                  Our fleet includes Hatchbacks, Sedans, SUVs,
                  Innova Crysta, Ertiga, Tempo Travellers, and Luxury
                  Cars driven by professional chauffeurs. With 24x7
                  support, transparent pricing, and punctual service,
                  we make every trip comfortable and hassle-free.
                </p>
              </div>

              <div className="vs-card">
                <span className="sec-subtitle">
                  Safe, Affordable & Comfortable Travel Solutions
                  Across Maharashtra & India
                </span>
              </div>

              <a href={buttonLink} className="vs-btn style5">
                {buttonText}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="feature--layout5">
        <div className="container">
          <div className="row">
            {features.map((feature, index) => (
              <div className="col-lg-4 mb-30" key={index}>
                <div className="item style2">
                  <div className="item__icon">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                    />
                  </div>

                  <div className="item__content">
                    <h3 className="item__title h4">
                      {feature.title}
                    </h3>

                    <p className="item__text">
                      {feature.text}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;